import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { CategoryService } from './../../services/category.service';
import { first } from 'rxjs/operators'

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss']
})
export class CategoryComponent implements OnInit {

  public category: any;
  public products: any;
  public subcategories: any;
  public category_name;
  public othercategories: any;
  public date: number = new Date().getTime()
  parameter
  constructor(
    public route:ActivatedRoute,
    public cs: CategoryService,
    public router: Router
    ){}

    ngOnInit() {
      this.route.queryParams.subscribe(async params=>{
        this.parameter = await params
        const id = await this.parameter.id;
        this.category_name = await this.parameter.id.name;

        console.log(params['id'])
        await this.cs.getProductsInCategories(id).then(ref=>{
          ref.subscribe(resp => {
            this.products = resp;
            console.log(this.products)
          })
        })        
      this.cs.getCategories().then(reference => {
        reference.subscribe(res=>{
          this.othercategories = res;
        })
      })
    })
  }


  navigate(product){
    console.log(product)
    let navigationExtras: NavigationExtras = {
      queryParams: {
        product: JSON.stringify(product)
      }
    };
    this.router.navigate(['product'], navigationExtras);
  }
}
